export default __webpack_public_path__ + "static/media/mobileBottomMenuLight.14bfdb32.svg";